var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaypal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 125,
    height: 32.002,
    viewBox: "0 0 125 32.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "paypal_1_",
    "data-name": "paypal (1)",
    transform: "translate(0 -187.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3966",
    "data-name": "Path 3966",
    d: "M357.735,221.2h-6.758a1.321,1.321,0,0,0-.994.8L347.2,239.487a.527.527,0,0,0,.6.6h3.578a.527.527,0,0,0,.6-.6l.8-4.969a.909.909,0,0,1,.994-.8h2.187q6.857,0,7.752-6.56a5.21,5.21,0,0,0-.8-4.373,8.018,8.018,0,0,0-5.168-1.59m.8,6.559c-.4,2.385-2.187,2.385-3.975,2.385h-1.193l.8-4.572c0-.2.2-.4.6-.4h.4c1.193,0,2.385,0,2.982.8.4.2.4.8.4,1.789",
    transform: "translate(-261.113 -25.252)",
    fill: "#139ad6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6217",
    "data-name": "Group 6217",
    transform: "translate(37.477 195.948)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3967",
    "data-name": "Path 3967",
    d: "M161.735,221.2h-6.758a1.321,1.321,0,0,0-.994.8L151.2,239.487a.527.527,0,0,0,.6.6h3.18a1.32,1.32,0,0,0,.994-.8l.8-4.771a.909.909,0,0,1,.994-.8h2.186q6.858,0,7.752-6.56a5.21,5.21,0,0,0-.8-4.373,7.64,7.64,0,0,0-5.168-1.59m.8,6.559c-.4,2.385-2.186,2.385-3.975,2.385h-.994l.8-4.572c0-.2.2-.4.6-.4h.4c1.193,0,2.385,0,2.982.8a2.129,2.129,0,0,1,.2,1.789",
    transform: "translate(-151.2 -221.2)",
    fill: "#263b80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3968",
    "data-name": "Path 3968",
    d: "M229.329,245.6h-3.18c-.2,0-.6.2-.6.4l-.2.994-.2-.4a4.676,4.676,0,0,0-3.777-1.391,7.638,7.638,0,0,0-7.355,6.559,5.924,5.924,0,0,0,1.193,4.969,5.009,5.009,0,0,0,4.174,1.59,6.353,6.353,0,0,0,4.572-1.789l-.2.994a.527.527,0,0,0,.6.6h2.982a1.321,1.321,0,0,0,.994-.8l1.789-11.131c-.2-.2-.6-.6-.8-.6m-4.572,6.361a3.845,3.845,0,0,1-3.777,3.18,3.178,3.178,0,0,1-2.186-.8,4.239,4.239,0,0,1-.6-2.385,3.545,3.545,0,0,1,5.764-2.385,3.47,3.47,0,0,1,.8,2.385",
    transform: "translate(-198.32 -239.237)",
    fill: "#263b80"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3969",
    "data-name": "Path 3969",
    d: "M424.529,245.6h-3.18c-.2,0-.6.2-.6.4l-.2.994-.2-.4a4.676,4.676,0,0,0-3.777-1.391,7.638,7.638,0,0,0-7.355,6.559,5.925,5.925,0,0,0,1.193,4.969,5.009,5.009,0,0,0,4.174,1.59,6.353,6.353,0,0,0,4.572-1.789l-.2.994a.527.527,0,0,0,.6.6h2.982a1.321,1.321,0,0,0,.994-.8l1.789-11.131c-.2-.2-.4-.6-.8-.6m-4.572,6.361a3.844,3.844,0,0,1-3.777,3.18,3.178,3.178,0,0,1-2.186-.8,4.239,4.239,0,0,1-.6-2.385,3.545,3.545,0,0,1,5.764-2.385,2.281,2.281,0,0,1,.8,2.385",
    transform: "translate(-307.679 -43.288)",
    fill: "#139ad6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3970",
    "data-name": "Path 3970",
    d: "M299.305,246.8h-3.379a1.033,1.033,0,0,0-.8.4l-4.373,6.758-1.988-6.361a.918.918,0,0,0-.994-.6H284.6c-.4,0-.6.4-.6.8l3.578,10.535L284.2,263.1c-.2.4,0,.994.4.994h3.18a1.033,1.033,0,0,0,.8-.4l10.932-15.7c.6-.6.2-1.193-.2-1.193",
    transform: "translate(-213.582 -44.491)",
    fill: "#263b80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3971",
    "data-name": "Path 3971",
    d: "M477.983,222.162,475.2,240.051a.527.527,0,0,0,.6.6h2.783a1.321,1.321,0,0,0,.994-.8l2.783-17.492a.527.527,0,0,0-.6-.6h-3.18c-.2-.2-.4,0-.6.4",
    transform: "translate(-357.356 -25.617)",
    fill: "#139ad6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3972",
    "data-name": "Path 3972",
    d: "M22.859,189.985c-1.391-1.59-3.975-2.385-7.553-2.385H5.367a1.705,1.705,0,0,0-1.391,1.193L0,214.832a.909.909,0,0,0,.8.994H6.957l1.59-9.74v.4a1.705,1.705,0,0,1,1.391-1.193H12.92c5.764,0,10.137-2.385,11.529-8.945v-.6h0c.2-2.584-.2-4.174-1.59-5.764",
    fill: "#263b80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3973",
    "data-name": "Path 3973",
    d: "M43.489,220.4h0v.6c-1.391,6.758-5.764,8.945-11.529,8.945H28.979a1.705,1.705,0,0,0-1.391,1.193L25.6,243.259a.728.728,0,0,0,.8.8h5.168a1.113,1.113,0,0,0,1.193-.994v-.2l.994-6.162v-.4a1.113,1.113,0,0,1,1.193-.994h.8c4.969,0,8.945-1.988,9.939-7.951.4-2.385.2-4.572-.994-5.963a2.035,2.035,0,0,0-1.193-.994",
    transform: "translate(-19.239 -24.65)",
    fill: "#139ad6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3974",
    "data-name": "Path 3974",
    d: "M48.712,216.2c-.2,0-.4-.2-.6-.2a.73.73,0,0,1-.6-.2,10.5,10.5,0,0,0-2.584-.2H37.183a.73.73,0,0,0-.6.2,1.093,1.093,0,0,0-.6.994L34.4,227.129v.4a1.705,1.705,0,0,1,1.391-1.193h2.982c5.764,0,10.137-2.385,11.529-8.945a.73.73,0,0,1,.2-.6c-.4-.2-.6-.4-.994-.4-.6-.2-.6-.2-.8-.2",
    transform: "translate(-25.853 -21.043)",
    fill: "#232c65"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypal);
export default __webpack_public_path__ + "static/media/paypal.74be7304ad8c60730a85fa56863b4b89.svg";
export { ForwardRef as ReactComponent };